import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";

const SNOOZE = "rosterly_unlinked_snooze";

// Forced owner/admin alert while any player is unlinked (signing news / draft picks).
export default function UnlinkedAlert() {
    const { user } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const isAdmin = ["admin", "owner"].includes(user?.role);
    const [snoozed, setSnoozed] = useState(() => sessionStorage.getItem(SNOOZE) === "1");
    const { data } = useQuery({ queryKey: ["admin-tasks-links"], queryFn: () => api.get("/admin/tasks/count").then((r) => r.data.links || 0), enabled: isAdmin, refetchInterval: 5 * 60 * 1000 });
    if (!isAdmin || !data || snoozed || loc.pathname === "/tasks") return null;
    const later = () => { sessionStorage.setItem(SNOOZE, "1"); setSnoozed(true); };
    return (
        <div className="fixed inset-0 z-[100002] flex items-center justify-center bg-black/80 backdrop-blur-md p-4" data-testid="unlinked-alert">
            <div className="w-full max-w-md rounded-2xl border border-[#EF4444]/50 bg-[#0B0C12] shadow-2xl p-6">
                <div className="flex items-center gap-2 text-[#EF4444] mb-2">
                    <AlertTriangle className="h-5 w-5" />
                    <span className="text-[11px] font-black uppercase tracking-[0.3em]">Action required</span>
                </div>
                <h2 className="text-xl font-black text-white" data-testid="unlinked-alert-count">{data} unlinked player{data === 1 ? "" : "s"}</h2>
                <p className="mt-2 text-[13px] text-[#94A3B8] leading-relaxed">A signing or draft pick couldn&apos;t be matched to a player, so it hasn&apos;t been applied. Link each one manually in Tasks.</p>
                <div className="mt-5 flex items-center justify-end gap-2">
                    <button type="button" onClick={later} data-testid="unlinked-alert-later" className="px-4 py-2.5 text-xs font-black uppercase tracking-wider text-white/50 hover:text-white">Later</button>
                    <button type="button" onClick={() => nav("/tasks")} data-testid="unlinked-alert-go" className="px-5 py-2.5 rounded-full bg-[#EF4444] hover:bg-[#DC2626] text-white text-xs font-black uppercase tracking-wider">Link now</button>
                </div>
            </div>
        </div>
    );
}
